// Arabic translations for the deeper product & process descriptions.
export const CAT_DESC_AR = {
  spices: "بهارات كاملة مصنّفة يدوياً من أفضل مناطق الزراعة في الهند.",
  powders: "مساحيق مطحونة طازجة بلون وعطر وقوة حقيقية.",
  rice: "أرز عطري طويل الحبة ويومي، نظيف بالسورتكس ومعبّأ للتصدير.",
  oils: "زيوت طعام معصورة على البارد ومفلترة مرتين، نقية وغير مغشوشة.",
  seeds: "بذور وأطعمة خارقة نظيفة ومصنّفة بالسورتكس للعلامات الغذائية العالمية.",
  millets: "دخن قديم خالٍ من الغلوتين يواكب موجة الحبوب الكاملة عالمياً.",
  snacks: "وجبات خفيفة نظيفة الملصق مصممة لرفوف التجزئة الصحية الحديثة.",
  sweeteners: "محلّيات طبيعية — جاغري كامل ومطحون وسكر مكرر.",
  "honey-ghee": "عسل طبيعي نقي وسمن بلدي تقليدي، معبّأ ومختوم للتصدير.",
  textiles: "ملابس منسوجة وأزياء موحّدة ومفروشات منزلية حسب مواصفات المشتري.",
};

export const PROCESS_AR = {
  "01": { title: "من المزارعين مباشرة", body: "نشتري مباشرة من المزارعين الذين يزرعونها — علاقات طويلة الأمد تضمن الطزاجة والتتبّع وسعراً عادلاً وشفافاً بلا وسطاء." },
  "02": { title: "الفرز والتصنيف داخلياً", body: "تنتقل كل شحنة إلى وحدة الفرز الخاصة بنا حيث تُنظّف وتُصنّف بالسورتكس وتُفحص جودتها لتمرّ الدرجة التي طلبتها فقط." },
  "03": { title: "التعبئة حسب مواصفاتك", body: "تقوم وحدة التعبئة لدينا بالتعبئة وفق متطلباتك تماماً — حجم الأكياس، العلامة الخاصة، الكراتين أو السائب — جاهزة للرفوف أو التوزيع بالجملة." },
  "04": { title: "الشحن إلى مينائك", body: "مستندات تصدير كاملة وتحميل الحاويات وشركاء شحن موثوقون يوصّلون طلبك في الوقت المحدد — نخدم بالفعل اليمن ودبي وعُمان." },
};

export const STRENGTHS_AR = {
  "01": { title: "من المصدر مباشرة", body: "نشتري مباشرة من المزارع والأسواق في الهند — بلا وسطاء، فتحصل على درجات صادقة بأسعار صادقة." },
  "02": { title: "رقابة جودة صارمة", body: "كل شحنة تُنظّف بالسورتكس وتُفحص رطوبتها وتُختبر معملياً قبل مغادرة منشأتنا." },
  "03": { title: "امتثال جاهز للتصدير", body: "شهادات الصحة النباتية والملصقات المخصصة ومستندات التصدير الكاملة تُدار من البداية للنهاية." },
  "04": { title: "لوجستيات عالمية موثوقة", body: "شركاء شحن موثوقون وتتبّع مباشر للشحنات — نخدم بالفعل اليمن ودبي وعُمان." },
  "05": { title: "كميات طلب مرنة", body: "من حاوية تجريبية إلى طلبات ضخمة متكررة، ننمو مع أعمالك مع ثبات الجودة." },
};

export const TEXTILE_AR = {
  heading: "بيت المنسوجات الخاص بنا.",
  body: "إلى جانب السلع الزراعية، ندير منشأة ملابس متكاملة (قص حتى التعبئة) في بالامانير — موقع استراتيجي في منتصف طريق بنغالور–تشيناي السريع. نصنّع المنسوجات والتريكو من البداية إلى النهاية لتُصنع ملابسك وتُنهى وتُعبّأ تحت سقف واحد وفق مواصفاتك.",
  caps: [
    { title: "قص حتى التعبئة", body: "خط داخلي كامل من قص القماش حتى الكراتين المعبأة." },
    { title: "تصنيع المنسوجات", body: "قمصان، بناطيل، أزياء موحّدة، ملاءات ومفروشات منزلية." },
    { title: "تصنيع التريكو", body: "تيشيرتات وبناطيل رياضية وملابس تريكو يومية بكميات كبيرة." },
    { title: "جاهز لمواصفات المشتري", body: "علامة خاصة، مقاسات متكاملة وتشطيب بمستوى التصدير." },
  ],
};
